goog.module('yext.entity.edit.EntityCluster');
goog.module.declareLegacyNamespace();
const EntityClusterGuard = goog.require('yext.entity.edit.EntityClusterGuard');

/**
 * Contains data relevant to the current entity's cluster
 *
 * @author Sean Egan (segan@yext.com)
 */
const EntityCluster = class {
  constructor($container) {
    if ($container.length) {
      this.clusterUpdateUrl = $container.data('clusterUpdateUrl');
      this.isIncompleteCluster = $container.data('isIncompleteCluster');
      this.hasMultipleClusters = $container.data('hasMultipleClusters');
      this.guardedFields = $container.data('guardedFields');
    } else {
      // TODO(segan): Remove this after migration from LocationEdit to EntityEdit
      this.clusterUpdateUrl = yext.locationcluster.CONFIG.allLocationsUrl;
      this.isIncompleteCluster = yext.locationcluster.CONFIG.isIncompleteCluster;
      this.hasMultipleClusters = yext.locationcluster.CONFIG.hasMultipleClusters;
      this.guardedFields = yext.locationcluster.CLUSTER_GUARDED_FIELDS;
    }
  }

  shouldShowWarningDialog(entityFieldName) {
    return this.guardedFields.indexOf(entityFieldName) >= 0
      && (this.isIncompleteCluster || this.hasMultipleClusters);
  }

  createClusterGuard(field) {
    return new EntityClusterGuard(field, this);
  }
};

exports = EntityCluster;
